import StockoutCategoryPanel from './stockoutCategoryPanel.container';

export default StockoutCategoryPanel;